export { CardComponent } from './card/card.component';
